import type { LineElement } from '@/components/canvas/document/publicTypes';
import { firstStroke } from '@/components/canvas/elements/model';

export async function drawLine(ctx: CanvasRenderingContext2D, el: LineElement) {
  const { x, y } = el.layout;
  const stroke = firstStroke(el.appearance);
  const strokeWidth = stroke?.width ?? 2;
  const strokeColor = stroke?.color ?? '#000';
  const strokeStyle = stroke?.style ?? 'solid';
  const start = el.data.start ?? { x: 0, y: 0 };
  const end = el.data.end ?? { x: el.size.width, y: 0 };
  ctx.beginPath();
  ctx.moveTo(x + start.x, y + start.y);
  ctx.lineTo(x + end.x, y + end.y);
  ctx.strokeStyle = strokeColor;
  ctx.lineWidth = strokeWidth;
  if (strokeStyle === 'dashed') ctx.setLineDash([strokeWidth * 3, strokeWidth * 2]);
  else if (strokeStyle === 'dotted') ctx.setLineDash([strokeWidth, strokeWidth]);
  else ctx.setLineDash([]);
  ctx.stroke();
  ctx.setLineDash([]);
}
